import { SubmissionChannels } from '@enums'
import BrandFanInfluencerIdentityRowPerformanceAverageEngagementPercent from './AverageEngagementPercent'
import BrandFanInfluencerIdentityRowPerformanceAverageImpressions from './AverageImpressions'
import BrandFanInfluencerIdentityRowPerformanceAverageReachPercent from './AverageReachPercent'
import BrandFanInfluencerIdentityRowPerformanceCollabs from './Collabs'
import BrandFanInfluencerIdentityRowPerformanceFollowers from './Followers'
import { useBrandFanInfluencerIdentityPerformance } from './usePerformance'

interface IProps {
  identityId: number
  provider: SubmissionChannels
  brandFanMemberId?: number
  brandFanGroupId?: number
}

export const BrandFanInfluencerIdentityRowPerformance: React.FC<IProps> = ({
  provider,
  identityId,
  brandFanGroupId,
  brandFanMemberId,
}) => {
  const {
    followerCount,
    averageEngagementPercent,
    averageImpressions,
    collabs,
    averageReach,
  } = useBrandFanInfluencerIdentityPerformance({ identityId, brandFanGroupId, brandFanMemberId })
  return (
    <>
      <BrandFanInfluencerIdentityRowPerformanceFollowers
        followerCount={followerCount}
        provider={provider}
      />
      <BrandFanInfluencerIdentityRowPerformanceAverageEngagementPercent
        averageEngagementPercent={averageEngagementPercent ?? 0}
        provider={provider}
      />
      <BrandFanInfluencerIdentityRowPerformanceAverageReachPercent
        averageReach={averageReach ?? 0}
        provider={provider}
      />
      <BrandFanInfluencerIdentityRowPerformanceAverageImpressions
        averageImpressions={averageImpressions ?? 0}
        provider={provider}
      />
      <BrandFanInfluencerIdentityRowPerformanceCollabs collabs={collabs} />
    </>
  )
}

export default BrandFanInfluencerIdentityRowPerformance
